var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDividerReversed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-fd0f1740-f2ab-417e-a012-1bad90d29bc3",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 858.9913 15.1064",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-7c295503-d8ed-45ad-9455-b0b78b558ab7",
    "data-name": "line_2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 858.9913,
    y1: 2,
    x2: 0,
    y2: 2,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "413.2041 2 424.3105 13.1064 589.3743 13.1064 754.4381 13.1064 765.5445 2",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "68.422 2 79.5284 13.1064 244.5922 13.1064 289.3482 13.1064 300.4546 2",
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.9121,
    y1: 9.5426,
    x2: 421.457,
    y2: 9.5426,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 521.7951,
    y1: 13.1064,
    x2: 533.4759,
    y2: 1.4256,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 529.6248,
    y1: 13.1064,
    x2: 541.3057,
    y2: 1.4256,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 245.1595,
    y1: 13.1064,
    x2: 256.8404,
    y2: 1.4256,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.9893,
    y1: 13.1064,
    x2: 264.6702,
    y2: 1.4256,
    fill: "none",
    stroke: "#ffd58d",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDividerReversed);
export default __webpack_public_path__ + "static/media/divider-reversed.a008c573960091829fbecb53ad5a3076.svg";
export { ForwardRef as ReactComponent };